
<form #giftCardForm="ngForm" [ngClass]="{'_load-animate _load-active': loading}">


  <div class="_dialog-title">
    <div class="flex-grow-1">{{args.title | translate}}</div>
    <button mat-icon-button mat-dialog-close class="dialog-close-button">
      <mat-icon aria-label="Close Dialog">close</mat-icon>
    </button>
  </div>

  <div class="_dialog-content pt-2">
    @switch (args.mode) {
      @case ('set') {
        <div class="list-group">
          @for (account of $storage.giftCards.accounts; track account) {
            <a class="list-group-item list-group-item-action" (click)="selectAccount(account)">
              {{account.name}}
            </a>
          }
        </div>
      }
      @case ('select') {
        @if (giftCard.hideOTP) {
          <mat-form-field appearance="outline" class="display-block">
            <mat-label>{{'_GIFTCARD.number' | translate}}</mat-label>
            <input [(ngModel)]="giftCard.pan" name="giftCardPan" matInput placeholder="{{'_GIFTCARD.number' | translate}}" type="tel" required
              [pattern]="panPattern" [disabled]="loading">
              @if (giftCard.pan) {
                <mat-icon matSuffix accessible [attr.aria-label]="appService.translate('ACCESS.delete')" aria-hidden="false" role="button" (click)="giftCard.pan = null" >close</mat-icon>
              }
            </mat-form-field>
          }
          <div class="otp text-center mb-2">
            @if (!giftCard.hideOTP) {
              <div>{{otpMessage? otpMessage : '_GIFTCARD.otp_required' | translate}}</div>
            }
            @if (!giftCard.hideOTP && otpMessage && otpMessageNumber) {
              <div>{{otpMessageNumber}}</div>
            }
          </div>
          @if (!giftCard.hideOTP) {
            <mat-form-field appearance="outline" class="display-block">
              <mat-label>{{'_GIFTCARD.otp_alt' | translate}}</mat-label>
              <input [(ngModel)]="giftCard.otp" name="otp" matInput type="tel" required
                [maxlength]="4" pattern="[0-9]*" [disabled]="loading">
              </mat-form-field>
            }
            @if (!giftCard.hideCVV) {
              <mat-form-field appearance="outline" class="display-block">
                <mat-label>{{'_GIFTCARD.cvv' | translate}}</mat-label>
                <input [(ngModel)]="giftCard.cvv" name="cvv" matInput type="tel" required
                  pattern="[0-9]*" [disabled]="loading">
                  @if (giftCard.cvv) {
                    <mat-icon matSuffix [attr.aria-label]="appService.translate('ACCESS.delete')" aria-hidden="false" role="button" (click)="giftCard.cvv = null">close</mat-icon>
                  }
                </mat-form-field>
              }
            }
            @case ('amount') {
              <ul class="list-group">
                <li class="list-group-item list-group-item-info d-flex">
                  <div class="flex-grow-1">{{'_GIFTCARD.balance' | translate}}</div>
                  <div class="gift-card-balance-price">{{giftCard.balance | lcurrency}}</div>
                </li>
                <li class="list-group-item list-group-item-info d-flex">
                  <div class="flex-grow-1">{{'PO.REMAINED_PAY' | translate}}</div>
                  <div class="gift-card-balance-price">{{maxAmount | lcurrency}}</div>
                </li>
              </ul>
              <hr />
              <div>
                <mat-form-field appearance="outline" class="display-block">
                  <mat-label>{{'_GIFTCARD.amount' | translate}}</mat-label>
                  <input [(ngModel)]="giftCard.amount" name="splitamount" matInput type="number" min="1" [max]="maxAmount" pattern="[0-9]+([\.,][0-9]+)?" required>
                  @if (giftCard.amount) {
                    <mat-icon matSuffix (click)="giftCard.amount = null" accessible [attr.aria-label]="appService.translate('ACCESS.delete')" aria-hidden="false" role="button">close</mat-icon>
                  }
                  @if (giftCard.amount) {
                    <mat-hint style="color: #ff6e40">
                      @if (giftCard.amount < 1) {
                        <div>
                          {{appService.translate('INVALID_AMOUNT_MIN', args.minT)}}
                        </div>
                      }
                      @if (giftCard.amount > args.maxAmount) {
                        <div>
                          {{appService.translate('INVALID_AMOUNT_MAX', args.maxT)}}
                        </div>
                      }
                    </mat-hint>
                  }
                </mat-form-field>
              </div>
            }
          }
        </div>

        <div class="_bottom-actions">
          <button
            type="submit"
            mat-flat-button color="primary"
            class="apply-gift-card rounded lg block"
            (click)="apply(giftCardForm)"
            [disabled]="loading || (!giftCard.hideOTP && !validCodeLength)"
            [ngClass]="{ 'disable-click': !giftCard.hideOTP && !validCodeLength }">
            {{args.actionTitle | translate}}
          </button>
          @if (!giftCard.hideOTP) {
            @if (countdownValue$ | async; as countdownValue) {
              <div
                class="resend-code disable-click"
                accessible
                >
                {{'did_not_arrive_resend' | translate}}
                ({{ countdownValue }})
              </div>
            }
            @if (countdownDone) {
              <div
                class="resend-code"
                (click)="checkGiftCard(true)"
                accessible
                >
                {{'did_not_arrive_resend' | translate}}
              </div>
            }
          }
        </div>
      </form>
